import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import Spinner from '@/ui/components/shared/Spinner/Spinner';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

type ListSelectProps = {
  disabled?: boolean;
  onChange: (value: any) => void;
  currentValue: any;
  list: { label: string; value: string }[];
  defaultSelectLabel: string;
};

export function ListSelect({
  disabled = false,
  onChange,
  currentValue,
  defaultSelectLabel,
  list,
}: ListSelectProps) {
  let selectedLabel = list.find((item) => item.value === currentValue)?.label;
  selectedLabel = selectedLabel || defaultSelectLabel;

  return (
    <Listbox onChange={onChange} value={currentValue} disabled={disabled}>
      <div className="relative">
        <Listbox.Button
          className={clsx(
            'flex w-full items-center justify-between rounded-xs border border-neutral-50 bg-white p-3 outline-none focus:border-neutral-100 ui-open:border-neutral-100',
            {
              '!bg-gray-50': disabled,
            },
          )}
        >
          {selectedLabel || <Spinner />}
          {!disabled && (
            <ChevronDownIcon className="h-6 w-auto transition-transform duration-200 ui-open:rotate-180" />
          )}
        </Listbox.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute mt-1 max-h-50 w-full overflow-y-auto overflow-x-hidden rounded-xs border border-neutral-100 bg-white">
            {list.map(({ label, value }, i) => (
              <Listbox.Option
                key={i}
                className="cursor-pointer px-4 py-2 ui-selected:bg-neutral-10 ui-selected:font-bold ui-active:bg-neutral-15"
                value={value}
              >
                {label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
